import { asset } from "./asset";
import { avatar } from "./avatar";
import { bg } from "./background";
import { border } from "./border";
import { decoration } from "./decoration";
import { grid } from "./grid";
import { interactions } from "./interactions";
import { masonry } from "./masonry";
import { pack } from "./pack";
import { transitions } from "./transitions";
import { searchBadge } from './searchBadge';
import { dropZone } from "./dropZone";
import { markdown } from "./markdown";
import { getStarted } from "./getStarted";
import { radioCard } from './radioCard';

export const layerStyles = {
  ...masonry,
  ...radioCard,
  ...border,
  ...avatar,
  ...pack,
  ...grid,
  ...bg,
  ...transitions,
  ...interactions,
  ...searchBadge,
  ...decoration,
  ...asset,
  ...dropZone,
  ...markdown,
  ...getStarted,
  ...radioCard,
};
